import React from 'react';
import { propTypes } from './props';
import { RowContainer } from './styled';
import { StrokePicker } from '../StrokePicker';
import { OpacityPicker } from '../OpacityPicker';
import { ToolBarButtonWrapper } from '../ToolBarButtonWrapper';
import { ColorBox } from '../ColorBox';
import { StyledText } from '@/generic/Styled';
import { isElementOfSameType } from '@/utils';
import { elementTypes } from '@/constants';
import { TEXT_DICTIONARY } from '@/constants/textConstants';
import theme from '@/theme';

export const ImageToolBar = ({
    imageStrokeWidth,
    imageStrokeColor,
    imageOpacity,
    onChangeImageStrokeWidth,
    onChangeImageStrokeColor,
    onChangeImageOpacity,
    imageTintColor,
    imageTintStrength,
    onChangeImageTintColor,
    onChangeImageTintStrength,
    onClearImageTint,
    selectedElement,
    languageLocale,
}) => {
    const isSelectedImage = isElementOfSameType(selectedElement, elementTypes.image);

    return (
        <RowContainer>
            <StrokePicker
                value={
                    isElementOfSameType(selectedElement, elementTypes.image)
                        ? selectedElement?.strokeWidth
                        : imageStrokeWidth
                }
                onChangeStrokeWidth={onChangeImageStrokeWidth}
                strokeColor={
                    isElementOfSameType(selectedElement, elementTypes.image)
                        ? selectedElement?.stroke
                        : imageStrokeColor
                }
                onChangeShapeStrokeColor={onChangeImageStrokeColor}
                languageLocale={languageLocale}
            />
            <OpacityPicker
                tooltip={TEXT_DICTIONARY?.[languageLocale]?.IMAGE_OPACITY}
                value={
                    isElementOfSameType(selectedElement, elementTypes.image)
                        ? selectedElement?.opacity
                        : imageOpacity
                }
                onChangeOpacity={onChangeImageOpacity}
                languageLocale={languageLocale}
            />
            {isSelectedImage && (
                <ToolBarButtonWrapper
                    gap={8}
                    tooltip={TEXT_DICTIONARY?.[languageLocale]?.MONOCHROME_COLOR}
                    tooltipPosition={'bottom'}
                >
                    <StyledText fontFamily={theme.fonts.secondary}>
                        {TEXT_DICTIONARY?.[languageLocale]?.MONOCHROME_COLOR}
                    </StyledText>
                    <ColorBox
                        backgroundColor={selectedElement?.tintColor || imageTintColor}
                        onChange={onChangeImageTintColor}
                    />
                </ToolBarButtonWrapper>
            )}
            {isSelectedImage && (
                <OpacityPicker
                    tooltip={TEXT_DICTIONARY?.[languageLocale]?.MONOCHROME_STRENGTH}
                    tooltipPosition={'bottom'}
                    value={selectedElement?.tintStrength ?? imageTintStrength}
                    min={0}
                    max={1}
                    step={0.05}
                    onChangeOpacity={onChangeImageTintStrength}
                    leftChild={
                        <StyledText fontFamily={theme.fonts.secondary}>
                            {TEXT_DICTIONARY?.[languageLocale]?.TINT_SHORT}
                        </StyledText>
                    }
                />
            )}
            {isSelectedImage && (
                <ToolBarButtonWrapper
                    gap={8}
                    tooltip={TEXT_DICTIONARY?.[languageLocale]?.CLEAR_MONOCHROME}
                    tooltipPosition={'bottom'}
                    onClick={onClearImageTint}
                    disabled={(selectedElement?.tintStrength ?? 0) <= 0}
                >
                    <StyledText fontFamily={theme.fonts.secondary}>
                        {TEXT_DICTIONARY?.[languageLocale]?.CLEAR_MONOCHROME}
                    </StyledText>
                </ToolBarButtonWrapper>
            )}
        </RowContainer>
    );
};

ImageToolBar.propTypes = propTypes;
